// Pure pricing layer over calculateLaborHours output.
// price = cost / (1 - margin); margin clamped to [0, 0.95].

import { LABOR_CATEGORY_KEYS as CATEGORIES } from './categories';

function clampMargin(m) {
  const n = Number(m) || 0;
  return Math.min(0.95, Math.max(0, n));
}

export function priceTakeoff(hoursResult, settings = {}) {
  const rates = settings.rates || {};
  const margin = clampMargin(settings.margin);
  const divisor = 1 - margin;

  const byCategory = (hoursResult && hoursResult.byCategory) || {};

  const groups = CATEGORIES
    .map((category) => {
      const cat = byCategory[category];
      const annualHours = cat ? cat.annualTotal : 0;
      if (!annualHours || annualHours <= 0) return null;
      const hourlyRate = Number(rates[category]) || 0;
      const annualCost = annualHours * hourlyRate;
      const annualPrice = divisor > 0 ? annualCost / divisor : 0;
      return {
        category,
        hourlyRate,
        crewSize: hoursResult.suggestedCrewSize || 1,
        annualHours,
        annualCost,
        annualPrice,
      };
    })
    .filter(Boolean);

  const annualHours = groups.reduce((s, g) => s + g.annualHours, 0);
  const annualCost = groups.reduce((s, g) => s + g.annualCost, 0);
  const annualPrice = groups.reduce((s, g) => s + g.annualPrice, 0);

  // Tier-2 cost enrichment: stamp each trace line with its category hourly rate
  // and annual cost. Additive — groups/totals shape unchanged. Guarded so the
  // trace key is only added to the return when the hours result carries one.
  const rateByCat = (cat) => Number(rates[cat]) || 0;
  const trace = Array.isArray(hoursResult && hoursResult.trace)
    ? hoursResult.trace.map((line) => {
        const hourlyRate = rateByCat(line.category);
        return { ...line, hourlyRate, annualCost: (line.annualHours || 0) * hourlyRate };
      })
    : undefined;

  return {
    groups,
    totals: {
      annualHours,
      annualCost,
      annualPrice,
      monthlyPrice: annualPrice / 12,
      margin,
    },
    ...(trace ? { trace } : {}),
  };
}

export default priceTakeoff;
